import { UserpilotIdentifyProperties } from './userpilot.service';

interface UserpilotOrg {
	group_id?: string | number | null;
	name: string;
}

const NO_ORG_NAME = 'No Org';

export const getUserpilotOrgProperties = (org: UserpilotOrg | null | undefined): UserpilotIdentifyProperties => {
	if (org == null) {
		return {
			org_name: NO_ORG_NAME
		};
	}

	return {
		...(org.group_id == null ? {} : { org_id: org.group_id }),
		org_name: org.name
	};
};
